/**
 *
 * Asynchronously loads the component for His001
 * Author: Thuantq1
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
